import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { SortingOrder, UserSortField } from "@/graphql/codegen/graphql"
import { UsersContainer } from "@/screens/SystemAdmin/containers"

const SearchParamsValidator = z.object({
  isActive: z.boolean().optional().nullish(),
  query: fallback(z.string().optional().default(""), ""),
  field: fallback(z.nativeEnum(UserSortField), UserSortField.Name),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
  roleIds: z.array(z.string()).optional(),
})

export const Route = createFileRoute("/app/admin/system-admin/_layout/users")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["query", "field", "order", "isActive", "roleIds"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.USER_MAINTENANCE]}>
      <UsersContainer />
    </PermissionContentWrapper>
  ),
})
